import ComponentCreator from '../../../helpers/component.creator';

import Checkbox from '../checkbox/checkbox.vue';
import MetadataInfo from '../metadata-info/metadata-info.vue';

import OptionsMixin from './options.mixin';

import FacetMoreOptionsPopup from './facet-more-options-popup.vue';

import keys from 'lodash/keys';
import transform from 'lodash/transform';
import isEmpty from 'lodash/isEmpty';
import keyBy from 'lodash/keyBy';
import reduce from 'lodash/reduce';

export default {
   name: 'Facet',
   props: {
      facet: {
         required: true
      },
      moreLoader: {
         required: true
      }
   },
   mixins: [ OptionsMixin ],
   components: { Checkbox, MetadataInfo },
   data() {
      return {
         collapsed: true,
         allSelectedAsText: '',
         selectedAsText: '',
         lastSelectedIdx: 0
      };
   },
   computed: {
      hasMore() {
         return this.facet.total > this.facet.items.length;
      },
      options() {
         return this.facet.items;
      },
      isAllSelected() {
         return isEmpty(this.selected);
      },
      getSelectedAsText() {
         const cache = keyBy(this.facet.items, 'id');
         return reduce(this.selected, (memo, key) => {
            const label = (cache[key] || {}).name || '';
            return memo ? `${memo}, ${label}`: label;
         }, '');
      }
   },
   methods: {
      async showMore() {
         const options = { loader: this.moreLoader, selected: keys(this.selectedAsMap) };
         try {
            const selected = await ComponentCreator.dialog(FacetMoreOptionsPopup, options);
            const selectedAsMap = transform(selected, (memo, id) => memo[id] = true, {});
            this.reselect(selectedAsMap);
         } catch(e) {
            //
         }
      },
      selectAll() {
         this.reselect({});
      }
   }
};
